import { useContext } from "react";
import { AuthContext } from "@/contexts/AuthContext";
import { useCompany } from "@/libs/hooks/useCompany";
import { useCompanyInfo } from "@/libs/hooks/useCompanyInfo";
import { useMe } from "@/libs/hooks/useMe";

import { GlobalHeaderDropDown } from "@/components/molecules/GlobalHeaderDropDown";
import { color, Font } from "@moneyforward/mfx_biz_react_components";

export const AccountDropDown = () => {
  return (
    <GlobalHeaderDropDown>
      <GlobalHeaderDropDown.Header icon="manageAccounts">
        設定
      </GlobalHeaderDropDown.Header>

      <GlobalHeaderDropDown.Body width={200}>
        <AccountDropDownItems />
        <GlobalHeaderDropDown.ItemSignOut />
      </GlobalHeaderDropDown.Body>
    </GlobalHeaderDropDown>
  );
};

export const AccountDropDownItems = () => {
  const { userInfo } = useContext(AuthContext);
  const { me, meLoading } = useMe();
  const { companyLoading, isAdmin } = useCompany();
  const { companyInfo, companyInfoLoading } = useCompanyInfo();
  const isIDAdmin = userInfo.authority === "admin";
  const isContractAdmin = isAdmin;

  const loading = meLoading || companyLoading || companyInfoLoading;

  return (
    <>
      {!loading && me && companyInfo && (
        <>
          <GlobalHeaderDropDown.Item height={72}>
            <div
              css={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Font variant="mb" type="jp">
                {me.lastName} {me.firstName}
              </Font>
              <div
                css={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 0,
                }}
              >
                <Font variant="s" type="jp" css={{ color: color.gray600 }}>
                  {companyInfo.companyNameStoreName}
                </Font>
                <Font variant="s" type="jp" css={{ color: color.gray600 }}>
                  事業者ID：{companyInfo.displayCompanyId}
                </Font>
              </div>
            </div>
          </GlobalHeaderDropDown.Item>
          <GlobalHeaderDropDown.Separator />
        </>
      )}
      {isIDAdmin && (
        <>
          <GlobalHeaderDropDown.ItemLink href="/manage-company">
            事業者管理
          </GlobalHeaderDropDown.ItemLink>
          <GlobalHeaderDropDown.ItemLink href="/manage-users">
            利用者管理
          </GlobalHeaderDropDown.ItemLink>
        </>
      )}
      {isContractAdmin && (
        <>
          <GlobalHeaderDropDown.ItemLink href="/contract-management">
            契約管理
          </GlobalHeaderDropDown.ItemLink>
        </>
      )}
      {(isIDAdmin || isContractAdmin) && (
        <>
          <GlobalHeaderDropDown.Separator />
        </>
      )}
    </>
  );
};
